import type { TrainingAttempt } from '../lib/types.ts';

// Admin-only score history for hosted training, grouped by module. Renders
// nothing when the entity has no attempts. Never render this in portal UI.
export function TrainingAttemptList({ attempts }: { attempts: TrainingAttempt[] }) {
  if (attempts.length === 0) return null;
  const byModule = new Map<string, { title: string; attempts: TrainingAttempt[] }>();
  for (const a of attempts) {
    const group = byModule.get(a.module_id) ?? { title: a.module_title, attempts: [] };
    group.attempts.push(a);
    byModule.set(a.module_id, group);
  }
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5">
      <h3 className="text-base font-semibold text-slate-800">Training</h3>
      <div className="mt-2 space-y-3">
        {[...byModule.entries()].map(([moduleId, group]) => (
          <div key={moduleId} className="rounded-md bg-slate-50 px-3 py-2">
            <div className="text-xs font-medium text-slate-500">
              {group.title} ({group.attempts.length} attempt
              {group.attempts.length === 1 ? '' : 's'})
            </div>
            <ul className="mt-1 space-y-0.5">
              {group.attempts.map((a) => (
                <li key={a.id} className="text-xs text-slate-600">
                  {a.status === 'completed' && a.score_pct !== null ? (
                    <>
                      <span
                        className={
                          a.passed ? 'font-medium text-emerald-700' : 'font-medium text-red-600'
                        }
                      >
                        {a.score_pct}% · {a.passed ? 'Passed' : 'Failed'}
                      </span>{' '}
                      · {new Date(a.completed_at ?? a.launched_at).toLocaleString()}
                    </>
                  ) : (
                    <>
                      <span className="text-slate-400">{a.status}</span> ·{' '}
                      {new Date(a.launched_at).toLocaleString()}
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
